import { inject, Injectable } from '@angular/core';
import { ConfirmationDialogService } from '@shared/components/widgets/dialog/confirmation/confirmation-dialog.service';
import { TaskUtils } from '@tasks/tasks.utils';
import { map, Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TaskPredecessorService {
  private confirmationService = inject(ConfirmationDialogService);
  private fieldIntendedToChange = '';
  constructor() {}

  isPredecessorAlertModalNeeded(
    task,
    fieldIntendedToChange,
  ): Observable<{ removePredecessors?: boolean; modalSkipped?: boolean }> {
    const hasLinkedTo = task.linked_to && task.linked_to.length > 0;
    const hasPredecessors = task.predecessors && task.predecessors.length > 0;

    if (!hasLinkedTo && !hasPredecessors) {
      return of({ modalSkipped: true });
    }
    this.fieldIntendedToChange = fieldIntendedToChange;
    if (fieldIntendedToChange === 'start_date') {
      return this.handleStartDateChange(task);
    } else if (fieldIntendedToChange === 'due_date') {
      return this.handleDueDateChange(task);
    }
  }

  private handleDueDateChange(task) {
    if (task.predecessors.some((p) => p.predecessor_type === 'SF' || p.predecessor_type === 'FF')) {
      return this.modalConfirmation(task);
    }

    return of({ modalSkipped: true });
  }

  private handleStartDateChange(task) {
    if (task.predecessors.some((p) => p.predecessor_type === 'FS' || p.predecessor_type === 'SS')) {
      return this.modalConfirmation(task);
    }

    return of({ modalSkipped: true });
  }

  private modalConfirmation(task) {
    return this.confirmationService
      .openConfirmationDialog({
        dialogTitle: `Confirmation`,
        description: TaskUtils.getEditStartDateConfirmationMessage(task, this.fieldIntendedToChange),
      })
      .pipe(
        map((result) => ({
          removePredecessors: result,
        })),
      );
  }
}
